const topics = [
  { label: '科幻巨制', hot: true, count: '2.3万讨论' },
  { label: '悬疑推理', hot: true, count: '1.8万讨论' },
  { label: '国产剧推荐', hot: true, count: '3.6万讨论' },
  { label: '韩剧精选', hot: false, count: '1.2万讨论' },
  { label: '美剧热播', hot: true, count: '2.1万讨论' },
  { label: '动画电影', hot: false, count: '9800讨论' },
  { label: '综艺搞笑', hot: true, count: '1.5万讨论' },
  { label: '纪录片', hot: false, count: '6200讨论' },
  { label: '高分经典', hot: true, count: '4.1万讨论' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">大家都在讨论的影视热点</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <div
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-fill text-accent-500 text-xs"></i>
                </span>
              )}
              <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}